import ArtistArtworkRecordTile from "./ArtistArtworkRecordTile";

export default ArtistArtworkRecordTile;
